module.exports = {"name":"courseraOpenBadges","parameters":[{"name":"courseraBadgeEnabled","valid":[true,false],"value":false}]}